import PropTypes from 'prop-types';

const participationData = PropTypes.shape({
    classroomParticipations: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            classroomName: PropTypes.string,
            activityPoints: PropTypes.number,
            livePoints: PropTypes.number,
            totalPoints: PropTypes.number,
            gold: PropTypes.number,
            silver: PropTypes.number,
            bronze: PropTypes.number
        })
    ),
    classroomUsage: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            totalSignIns: PropTypes.number,
            totalTimeOnline: PropTypes.shape({
                hours: PropTypes.number,
                minutes: PropTypes.number
            }),
            totalActivityPoints: PropTypes.number,
            totalLivePoints: PropTypes.number
        })
    ),
    certificates: PropTypes.shape({
        gold: PropTypes.number,
        silver: PropTypes.number,
        bronze: PropTypes.number
    })
});

export default {
    participationData
};



// WEBPACK FOOTER //
// ./containers/participation/all-classes/all-classes-prop-types.js